import { initializeApp, getApps, FirebaseApp } from 'firebase/app';
import { 
  getAuth, 
  Auth,
  signInWithEmailAndPassword as _signInWithEmailAndPassword,
  createUserWithEmailAndPassword as _createUserWithEmailAndPassword,
  signOut as _signOut,
  onAuthStateChanged as _onAuthStateChanged,
  updateProfile as _updateProfile,
} from 'firebase/auth';
import { 
  getFirestore, 
  Firestore,
  collection as _collection,
  doc as _doc,
  getDoc as _getDoc,
  getDocs as _getDocs,
  setDoc as _setDoc,
  updateDoc as _updateDoc,
  deleteDoc as _deleteDoc,
  query as _query,
  orderBy as _orderBy,
  limit as _limit,
  Timestamp,
  runTransaction as _runTransaction,
  addDoc as _addDoc,
  DocumentSnapshot,
  QueryDocumentSnapshot,
  Transaction,
} from 'firebase/firestore';
import { 
  getDatabase, 
  Database,
  ref as _ref,
  child as _child,
  set as _set,
  get as _get,
  update as _update,
  remove as _remove,
  onValue as _onValue,
  off as _off,
  push as _push,
  serverTimestamp as _serverTimestamp,
  DataSnapshot,
  DatabaseReference,
} from 'firebase/database';
import { firebaseConfig } from '../firebaseConfig';

// Initialize Firebase app (singleton pattern)
let app: FirebaseApp;
if (getApps().length === 0) {
  app = initializeApp(firebaseConfig);
} else {
  app = getApps()[0];
}

// Export initialized services
export const auth: Auth = getAuth(app);
export const firestore: Firestore = getFirestore(app);
export const database: Database = getDatabase(app);
export { app };

// Re-export Auth functions
export const signInWithEmailAndPassword = _signInWithEmailAndPassword;
export const createUserWithEmailAndPassword = _createUserWithEmailAndPassword;
export const signOut = _signOut;
export const onAuthStateChanged = _onAuthStateChanged;
export const updateProfile = _updateProfile;

// Re-export Firestore functions
export const collection = _collection;
export const doc = _doc;
export const getDoc = _getDoc;
export const getDocs = _getDocs;
export const setDoc = _setDoc;
export const updateDoc = _updateDoc;
export const deleteDoc = _deleteDoc;
export const query = _query;
export const orderBy = _orderBy;
export const limit = _limit;
export { Timestamp };
export const runTransaction = _runTransaction;
export const addDoc = _addDoc;

// Re-export Realtime Database functions
export const ref = _ref;
export const child = _child;
export const set = _set;
export const get = _get;
export const update = _update;
export const remove = _remove;
export const onValue = _onValue;
export const off = _off;
export const push = _push;
export const serverTimestamp = _serverTimestamp;

// Re-export types
export type { DataSnapshot, DatabaseReference, DocumentSnapshot, QueryDocumentSnapshot, Transaction };
